import React from 'react';
import LogoutHeader from '../../components/Headers/LogoutHeader';
import RegistrationPreview from '../../components/RegistrationPreview';
import LogoutFooter from '../../components/Footers/LogoutFooter';

const RegistrationPreviewPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main>
        <RegistrationPreview />
      </main>
      <LogoutFooter />
    </>
  )
}

export default RegistrationPreviewPage;